import { PublicKey } from "@solana/web3.js";
/**
 * The public key of the Solana SPL Associated Token Account program.
 */
export const SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID = new PublicKey("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
/**
 * The public key of the Solana SlotHashes sysvar.
 */
export const SLOT_HASHES_SYSVAR_ID = new PublicKey("SysvarS1otHashes111111111111111111111111111");
/**
 * The public key of the Solana Instructions sysvar.
 */
export const IX_SYSVAR_ID = new PublicKey("Sysvar1nstructions1111111111111111111111111");
//# sourceMappingURL=constants.js.map